import React, {useEffect, useState} from 'react';
import {Helmet} from "react-helmet";
import {NonHomeHeader} from "../../components/header/header";
import ContentLeft from "../../components/content/left";
import Footer from "../../components/footer/footer";
import {useLocation, useParams} from 'react-router-dom';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function getPagination(currentPage, totalPages, maxVisiblePages = 6) {
    const pagination = [];
    const half = Math.floor(maxVisiblePages / 2);

    // Calculate start and end page
    let start = Math.max(1, currentPage - half);
    let end = Math.min(totalPages, currentPage + half);

    // Adjust start and end if at the edges
    if (currentPage - half <= 0) {
        end = Math.min(totalPages, end + (half - currentPage + 1));
    }
    if (currentPage + half >= totalPages) {
        start = Math.max(1, start - (currentPage + half - totalPages));
    }

    // Add first page and ellipsis if needed
    if (start > 1) {
        pagination.push(1);
        if (start > 2) {
            pagination.push('previous');
        }
    }

    // Add visible page numbers
    for (let i = start; i <= end; i++) {
        pagination.push(i);
    }

    // Add last page and ellipsis if needed
    if (end < totalPages) {
        if (end < totalPages - 1) {
            pagination.push('next');
        }
        pagination.push(totalPages);
    }

    return pagination;
}

const ContentRight = () => {

    const query = useQuery();
    const {categoryId} = useParams();

    const [category, setCategory] = useState({
        "parent_list":[],
        "child_list":[]
    });
    const [series_page, setSeriesPage] = useState({
        "data":[]
    });


    useEffect(() => {
        const fetchData = () => {
            fetch("/api/category/info?categoryId="+categoryId).then(response => response.json()).then(data => {
                setCategory(data.data)
            })
        };

        fetchData();

        const fetchData1 = () => {
            const queryParams = new URLSearchParams({
                categoryId: categoryId, pageID: query.get("pageID")||1, ob: query.get("ob")||"pv", od: query.get("od")||"desc",
            }).toString();
            fetch("/api/series/page?"+queryParams, {
                method: 'POST', headers: {
                    'Content-Type': 'application/json',
                }, body: JSON.stringify({}),
            }).then(response => response.json()).then(data => {
                setSeriesPage(data.data)
                const v_page = data.data;
                let total_page = v_page.total_page;
                let page_no = v_page.page_no;
                let category_id = categoryId;
                let page_arr = getPagination(page_no,total_page,6)
                document.getElementById("page_number_foot").innerHTML = '';
                page_arr.forEach(function(page_item) {



                    let title = "page "+page_item;
                    let value = page_item;
                    let pageID = page_item
                    if (page_item ===1){
                        title = "first page";
                        value = "["+page_item+"]"
                    }else if (page_item === total_page){
                        title = "last page";
                        value = "["+page_item+"]"
                    }else if (page_item == 'previous'){
                        title = "previous page";
                        value = "« Previous"
                        pageID = page_no-1;
                    }else if (page_item == 'next'){
                        title = "next page";
                        value = "Next »"
                        pageID = page_no+1;
                    }

                    let _tpl = '&nbsp;<a href="'+("/categories/"+category_id+"?cid="+category_id+"&t=&et=&pageID="+pageID)+'" class="pager-link-gtm" title="'+title+'" aria-label="'+title+'" previewlistener="true">'+value+'</a>';
                    if (page_item === page_no){
                        document.getElementById("page_number_foot").innerHTML += '&nbsp;<b class="pager-link-gtm">'+page_item+'</b>'
                    }else {
                        document.getElementById("page_number_foot").innerHTML += _tpl
                    }


                });
            })
        };

        fetchData1();

    }, []);


    return (<div className="col-12 col-sm-9 content-2columns-main gx-4 subcategories">
        <nav id="breadcrumbs" className="site-breadcrumbs" aria-label="site breadcrumbs">
            <a className="breadcrumb_link" href="/categories">类别</a>
        </nav>
        <div id="page-title" className="page-title">
            <h2>{category.name}</h2>
        </div>
        <span className="message-container">
        </span>
        <div className="pager-container">
            <div className="panel category-panel">
                <form method="GET" name="mainform" action={'/categories/' + category.id}
                      style={{display: 'inline'}}>
                    <div className="panel-heading">
                <span className="panel-title panel-title-center text-muted float-start col-12 col-sm-11">
                    <h3>{category.name}</h3>
                  <p id="breadcrumbs" className="d-none d-sm-block">
                    <span>
                      <a className="breadcrumb_link" href="/categories">类别</a>
                        {category['parent_list'].map((item, index) => (
                            <span> &gt; <a className="breadcrumb_link" href={'/categories/' + item.id}>{item.name}</a></span>
                        ))}
                    </span>
                  </p>
                  <div className="dropdown show d-block d-sm-none dropdown-breadcrumbs">
                    <a className="breadcrumb_link" href="#" id="dropdownMenuLink" data-bs-toggle="dropdown"
                       aria-haspopup="true" aria-expanded="false">
                      类别
                    </a>
                    <div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                      <ul className="dropdown-breadcrumbs-listing">
                        <li className="dropdown-breadcrumbs-item ml0">
                          <a className="dropdown-item breadcrumb_link" href="/categories">类别</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                    {/* /dropdown */}
                </span>
                    </div>
                    <div className="col-12 panel-menu" style={{float: 'left', padding: 0}}>
                        <div className="subcats col-12">
                            <h2 className="hidden">{category.name}</h2>
                            {category.child_list.length > 0 ? (<div className="col-12 col-sm-6 float-start">
                                    <ul className="list-bullets pb-0" style={{}}>
                                        {category.child_list.map((item2, index) => (index % 2 == 0 ? (<li>
                                                    <a href={'/categories/' + item2.id}>{item2.name}</a>
                                                    &nbsp;
                                                    <span>{'(' + item2.num + ')'}</span>
                                                </li>) : ('')

                                        ))}

                                    </ul>
                                </div>) : ('')}

                            {category.child_list.length > 0 ? (<div className="col-12 col-sm-6 float-end">
                                    <ul className="list-bullets" style={{paddingRight: 20, paddingBottom: 0}}>
                                        {category.child_list.map((item2, index) => (index % 2 == 1 ? (<li>
                                                    <a href={'/categories/' + item2.id}>{item2.name}</a>
                                                    &nbsp;
                                                    <span>{'(' + item2.num + ')'}</span>
                                                </li>) : ('')

                                        ))}
                                    </ul>
                                </div>) : ('')}

                        </div>

                        {series_page.data.length > 0 ? (<div className="series-pager-header clear" style={{
                                borderTop: '1px solid #e2e2e2', marginBottom: '.5em', paddingLeft: 8, paddingTop: 12
                            }}>
                                <div className="dropdown float-end">
                                    <button
                                        className="series-fred-pager-btn dropdown-toggle btn btn-sm btn-default sort-series-gtm"
                                        data-bs-toggle="dropdown" id="order-by-btn" role="combobox"
                                        aria-controls="order_by_options-dropdown" aria-label="Sort by Popularity"
                                        aria-description="Choose an option from the list below">Sort by Popularity <i
                                        className="caret sort-series-gtm"/>
                                    </button>
                                    <ul className="dropdown-menu sort-dropdown" role="listbox"
                                        id="order_by_options-dropdown" aria-labeledby="order-by-btn">
                                        <li><a href="#" data-order-by="pv"
                                               className="sort-dropdown-item dropdown-item sort-series-pv-gtm"
                                               role="option" aria-selected="true" aria-label="Popularity">Popularity</a>
                                        </li>
                                        <li><a href="#" data-order-by="lu"
                                               className="sort-dropdown-item dropdown-item sort-series-lu-gtm"
                                               role="option" aria-selected="false" aria-label="Updated">Updated</a></li>
                                        <li><a href="#" data-order-by="oe"
                                               className="sort-dropdown-item dropdown-item sort-series-oe-gtm"
                                               role="option" aria-selected="false" aria-label="Observation End">Obs
                                            End</a></li>
                                        <li><a href="#" data-order-by="os"
                                               className="sort-dropdown-item dropdown-item sort-series-os-gtm"
                                               role="option" aria-selected="false" aria-label="Observation Start">Obs
                                            Start</a></li>
                                        <li><a href="#" data-order-by="t"
                                               className="sort-dropdown-item dropdown-item sort-series-t-gtm"
                                               role="option" aria-selected="false" aria-label="Title">Title</a></li>
                                        <li><a href="#" data-order-by="f"
                                               className="sort-dropdown-item dropdown-item sort-series-f-gtm"
                                               role="option" aria-selected="false" aria-label="Frequency">Frequency</a>
                                        </li>
                                        <li><a href="#" data-order-by="u"
                                               className="sort-dropdown-item dropdown-item sort-series-u-gtm"
                                               role="option" aria-selected="false" aria-label="Units">Units</a></li>
                                        <li><a href="#" data-order-by="sa"
                                               className="sort-dropdown-item dropdown-item sort-series-sa-gtm"
                                               role="option" aria-selected="false" aria-label="seasonally adjusted">Seas
                                            Adj</a></li>
                                    </ul>
                                </div>
                                {/* /dropdown */}
                            </div>) : ('')}

                    </div>
                    <div className="panel-body ph20">
                        <input type="hidden" name="pageID" value={query.get('pageID') || 1}/>
                        <input type="hidden" name="ob" value={query.get('ob') || 'pv'}/>
                        <input type="hidden" name="od" value={query.get('od') || 'desc'}/>
                        <input type="hidden" name="t" value={query.get('t')}/>
                        <input type="hidden" name="et" value={query.get('et')}/>

                        <table border={0} id="series-pager" role="presentation" className="table-responsive">
                            <tbody>
                            {
                                series_page.data.map((item, index) => (
                                    <React.Fragment>
                                        <tr className="series-pager-title">
                                            <td valign="top" colSpan={2}>
                                                <div className="display-results-title col-xs-12 col-sm-10">
                                                    <h3><a id="titleLink"
                                                           href={"/series/" + item.child_list[0].series_id}
                                                           style={{fontSize: '1.2em', paddingBottom: 2}}
                                                           className="series-title pager-series-title-gtm"
                                                           previewlistener="true">{item.title}</a></h3>
                                                </div>
                                                <div className="display-results-popularity-bar d-none d-sm-block col-sm-2">
                                                  <span className="popularity-bar-span-parent" data-target={'popularity-bar-span-' + item.child_list[0].series_id} tabIndex={0} aria-label={'popularity' + item.popularity_group + '% popular'} title={item.popularity_group + '% popular'}>
                                                      <span aria-hidden="true" style={{
                                                          paddingTop: '3px',
                                                          paddingLeft: `${0.62 * item.popularity_group}px`
                                                      }} className="popularity_bar">&nbsp;</span>
                                                      <span id={'popularity-bar-span-' + item.popularity_group} aria-hidden="true" className="popularity_bar_background">&nbsp;</span>
                                                  </span>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="series-pager-attr">
                                            <td colSpan={2}>
                                                {
                                                    item.public_key_list.length > 0 ? (
                                                        <div className="series-meta series-group-meta">
                                                            {
                                                                item.public_key_list.map((public_key, iterStat1) => (
                                                                    <span className="attributes">
                                                                    {iterStat1 > 0 ? (<span className="attributes">,</span>) : ('')}
                                                                        <span className="attributes">{public_key}</span>
                                                                  </span>
                                                                ))
                                                            }
                                                            <br className="clear"/>
                                                        </div>
                                                    ) : ('')
                                                }

                                                <div className="series-meta">
                                                    {
                                                        item.child_list.map((child, iterStat2) => (
                                                            <div>
                                                                <input className="pager-item-checkbox pager-check-series-gtm"
                                                                       type="checkbox" name={'sids[' + iterStat2.index + ']'}
                                                                       value={child.series_id}
                                                                       aria-labelledby={'unitLink' + child.series_id}/>
                                                                <a id={'unitLink' + child.series_id}
                                                                   aria-describedby={'aria-target-' + child.series_id}
                                                                   className="pager-series-attributes-gtm"
                                                                   href={'/series/' + child.series_id} previewlistener="true">
                                                                    <span>
                                                                    {
                                                                        [child.units, child.frequency]
                                                                            .filter(f => !(item.public_key_list.includes(f))).join(" , ")
                                                                    }
                                                                    </span>

                                                                </a>
                                                                <span id={'aria-target-' + child.series_id}
                                                                      aria-label={'From ' + child.observation_start + ' to ' + child.observation_end + ' 1 day ago'}
                                                                      className="series-meta-dates">
                                                                      {child.observation_start_sort + ' to ' + child.observation_end_sort + ' (' + child.last_updated_short + ')'}
                                                                </span>
                                                                <br className="clear"/>
                                                            </div>
                                                        ))
                                                    }

                                                </div>
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                ))
                            }

                            <tr>
                                <td colSpan={2} style={{fontSize: 9}}>&nbsp;</td>
                            </tr>
                            </tbody>
                        </table>
                        {series_page.data.length > 0 ? (
                            <div className="series-pager-header" style={{marginTop: '0.5em'}}>
                                <div id="add-multiple-graphs-to-dashboard-modal-container"/>
                            </div>
                        ) : ('')}

                        {/* /series-pager-header  */}
                        <br/>
                        <p style={{textAlign: 'right'}} id="page_number_foot"></p>
                    </div>
                </form>
            </div>
        </div>
            <button disabled id="filter-button"
            className="drawer-dropdown-trigger filter-tags-btn btn affix btn-block btn-default dropdown-is-active">
        <i className="fa fa-filter" style={{paddingRight: 5}}/>Filter <span
        className="badge badge-primary hidden">0</span></button>
</div>
)
}


const CategoriesIndex = () => {

    return (<div id='container' className='container'>
        <link rel="stylesheet" href='/static/css/1717421276.pager.min.css'/>
        <Helmet>
            <title>数据兔</title>
        </Helmet>
        <NonHomeHeader/>
        <div className='row clear' id='content-container'>
            <ContentLeft/>
            <ContentRight/>
            <Footer/>
        </div>
    </div>);
};

export default CategoriesIndex;
